/**
 * Mock Initiate Upload Responses
 *
 * Custom mock export for uploadInitiate endpoint.
 * Can be referenced via mock: "initiateUploadMock" in YAML or discovered by convention.
 *
 * Sample responses from POST /upload/initiate for development and testing.
 * These responses would be returned when the actual API endpoint is not yet available.
 *
 * The `storageProvider` field drives which upload implementation is used:
 *   - 'aws_s3'     → XHR PUT to pre-signed URL, success on HTTP 200
 *   - 'azure_blob' → XHR PUT to SAS token URL, success on HTTP 201
 */

export const MOCK_UPLOAD_INITIATE = {
  uploadId: 'up_8f3a2c1d-4e5b-6f7a-8b9c-0d1e2f3a4b5c',
  storageProvider: 'aws_s3' as const,
  uploadUrl:
    'https://conex-device-attachments.s3.us-east-1.amazonaws.com/attachments/images/device-DEV-001/sensor-photo.jpg' +
    '?X-Amz-Algorithm=AWS4-HMAC-SHA256' +
    '&X-Amz-Credential=AKIAIOSFODNN7EXAMPLE%2F20260302%2Fus-east-1%2Fs3%2Faws4_request' +
    '&X-Amz-Date=20260302T110000Z' +
    '&X-Amz-Expires=3600' +
    '&X-Amz-SignedHeaders=content-length%3Bcontent-type%3Bx-amz-content-sha256' +
    '&X-Amz-Signature=5d672d79c15b13162d9279b0855cfba6dd8d39ca4c4b1dcd4d082c69b4b0db14',
  requiredHeaders: {
    'Content-Type': 'image/jpeg',
    'Content-Length': '2097152',
    'x-amz-content-sha256': 'a665a45920422f9d417e4867efdc4fb8a04a1f3fff1fa07e998e86f7f7a27ae3',
  },
};

export const MOCK_INITIATE_UPLOAD_AZURE = {
  uploadId: 'up_1a2b3c4d-5e6f-7a8b-9c0d-1e2f3a4b5c6d',
  storageProvider: 'azure_blob' as const,
  uploadUrl:
    'https://conexstorage.blob.core.windows.net/device-attachments/attachments/images/device-DEV-002/camera-frame.png' +
    '?sv=2023-11-03' +
    '&ss=b' +
    '&srt=o' +
    '&sp=cw' +
    '&se=2026-03-02T12%3A00%3A00Z' +
    '&st=2026-03-02T11%3A00%3A00Z' +
    '&spr=https' +
    '&sig=Zm9vYmFyYmF6cXV4cXV4cXV4cXV4cXV4cXV4cXV4cXU%3D',
  requiredHeaders: {
    'Content-Type': 'image/png',
    'Content-Length': '1048576',
    'x-ms-blob-type': 'BlockBlob',
  },
};
